import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setUsers(r.data.customers)); }, []);

  return (
    <div className="p-8" data-testid="admin-customers-page">
      <div className="mb-6">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">SEGMENTATION</div>
        <h1 className="font-display text-5xl tracking-tighter mt-2">CUSTOMERS ({users.length})</h1>
      </div>
      <div className="border border-black/10 bg-white">
        <table className="w-full text-sm">
          <thead className="font-display tracking-widest text-xs text-black/50">
            <tr className="border-b border-black/10">
              <th className="text-left p-3">NAME</th>
              <th className="text-left p-3">EMAIL</th>
              <th className="text-right p-3">WALLET</th>
              <th className="text-left p-3">TIER</th>
              <th className="text-left p-3">JOINED</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-black/5">
                <td className="p-3 font-display tracking-tight">{u.name}</td>
                <td className="p-3 font-mono text-xs">{u.email}</td>
                <td className="p-3 text-right">{u.wallet_points || 0}</td>
                <td className="p-3"><span className="font-display tracking-widest text-xs text-[#FF3B30]">{(u.member_tier || "free").toUpperCase()}</span></td>
                <td className="p-3 font-mono text-xs text-black/50">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {!users.length && <tr><td colSpan="5" className="p-12 text-center text-black/40 font-mono text-xs">NO CUSTOMERS YET</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
